module.exports = __webpack_public_path__ + "public/images/summer-camp.88870605f8f0cbed72fd6f7a8943e4e5.jpg";